import { NavigationItem } from '.';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import AnalyticsOutlined from '@mui/icons-material/AnalyticsOutlined';
import DescriptionOutlined from '@mui/icons-material/DescriptionOutlined';
import GroupOutlined from '@mui/icons-material/GroupOutlined';
import PersonOutlined from '@mui/icons-material/PersonOutlined';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import PageInfoIcon from '@/components/icons/configuration';

const navigationItems: NavigationItem[] = [
  {
    text: 'Dashboard',
    route: '/dashboard',
    icon: <DashboardOutlinedIcon />,
  },
  {
    text: 'Client Services',
    icon: <PersonOutlined />,
    children: [
      { text: 'Clients' },
      { text: 'Prospects' },
      { text: 'Activity & Usage' },
    ],
  },
  {
    text: "Client's Wealth",
    icon: <AccountBalanceOutlinedIcon />,
    children: [
      { text: 'Accounts', route: '/clients-wealth/accounts' },
      { text: 'Holdings', route: '/clients-wealth/holdings' },
      { text: 'Asset Allocation', route: '/clients-wealth/asset-allocation' },
      { text: 'Balance Sheet', route: '/clients-wealth/balance-sheet' },
    ],
  },
  {
    text: 'Business Intelligence',
    route: '/business-intelligence',
    icon: <AnalyticsOutlined />,
    children: [
      { text: 'Metrics' },
      {
        text: 'AUM & Held Away',
        route: '/business-intelligence/aum-held-away',
      },
      { text: 'Insights', route: '/business-intelligence/insights' },
    ],
  },
  {
    text: 'Configuration',
    icon: <PageInfoIcon />,
    children: [
      { text: 'Client Portal' },
      { text: 'Managed Accounts' },
      { text: 'Integrations' },
    ],
  },
  {
    text: 'Documents',
    route: '/documents',
    icon: <DescriptionOutlined />,
    children: [
      { text: 'Document Vault' },
      { text: 'Reports' },
      { text: 'Notes' },
    ],
  },
  {
    text: 'Team',
    icon: <GroupOutlined />,
  },
];

export default navigationItems;
